var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "reimu-loading" }, [
      _c("div", { staticClass: "reimu-icon" }),
      _vm._v("\n  少女祈祷中...\n"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }